// extracted by mini-css-extract-plugin
export var description = "Description-module--description--7ccfa";
export var duration = "Description-module--duration--2417b";
export var durationIcon = "Description-module--durationIcon--857fb";
export var fadeInAnimation = "Description-module--fadeInAnimation--31e90";
export var wrapper = "Description-module--wrapper--70741";